import each from 'lodash/each'
import map from 'lodash/map'

// App Store
import { app } from '../utils/store'

// User Detect
import { DetectionManager } from '../utils/detect'

// Navigation
import { Navigation } from '../modules/Navigation'

// Classes::Managers
import { CursorManager } from '../modules/cursor'

// AsyncLoad
import AsyncLoad from '../classes/AsyncLoad'

// Modules
import Swiper from 'swiper/bundle'

// Animations
import Title from '../animations/Title';
import Paragraph from '../animations/Paragraph';
import Label from '../animations/Label';
import Parallax from '../animations/Parallax'


class App {
    constructor(){
        app.init = true
        app.root = document.body
        app.viewport = document.querySelector('[data-app-viewport]')

        //Async Load
        app.images = document.querySelectorAll('img[data-src][data-webp]')

        // Cursor::Only if is Desktop
        if(app.device.desktop){ CursorManager.create() }
        
        app.create = {
            content: this.createContent.bind(this),
            animation: this.createAnimations.bind(this),
            navigation: this.createNavigation.bind(this),
            preloaders: this.createPreloaders.bind(this),
        }
        
        map(app.create, (callback) => { return callback() })
        
        this.createCarousels(),

        console.log('App',app)
    }

    // Create Content
    createContent = () => {
        this.content = document.querySelector('main')
        this.template = this.content.getAttribute('data-template')

        app.content = this.content
        app.template = this.template
        app.current = this.template

        this.wrapper = document.querySelector('[data-wrapper]')

        app.wrapper = this.wrapper

        this.entrypoint = document.querySelector('[data-menu] .nav-item')

        this.dropdown = {
            togglers: document.querySelectorAll('[data-bs-toggle="dropdown"]'),
        }

        this.accordion = {
            togglers: document.querySelectorAll('.accordion-button'),
        }
        
        this.modal = {
            elements: document.querySelectorAll('[data-modal]'),
            togglers: document.querySelectorAll('[data-modal-target]'),
            closers: document.querySelectorAll('[data-modal-close]')
        }

        this.sliders = document.querySelectorAll('.slider')

        this.anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])')
        this.carousels = document.querySelectorAll('[data-carousel]')
        this.header = document.querySelector('header')
        this.forms = document.querySelectorAll('form')

        app.current = this.template
        app.wrapper = this.wrapper

        //Animations
        this.animated = {
            titles: document.querySelectorAll('[data-animation="title"]'),
            paragraphs: document.querySelectorAll('[data-animation="paragraph"]'),
            labels: document.querySelectorAll('[data-animation="label"]'),
            parallaxed: document.querySelectorAll('[parallax]')
        }
    }

    // Create Navigation
    createNavigation = () => {
        app.navigation = new Navigation()
        // app.footer = new Footer()
    }

    // Create Preloaders
    createPreloaders = () => {
        app.loading = false

        this.preloaders = each(app.images, image => {
            return new AsyncLoad({ element: image })
        })

        if(app.preloader){ app.preloader.destroy() }
        this.onResize
    }

    // Create Carousel
    createCarousels = () => {
        if(this.carousels){
            each(this.carousels, (carousel) => {
                let swiper = new Swiper(carousel, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    // grabCursor: true,
                    // draggable: true,
                    autoplay: { delay: 0.1 },
                    speed: 3000,
                    lazy: {
                        enabled: true,
                        loadOnTransitionStart: true
                    },
                    // centeredSlides: true,
                    // centeredSlidesBounds: true,
                    loop: true,
                    rewind: false,
                    navigation: false
                })
            })
        }
    }

    // Create Animations
    createAnimations() {
        app.animations = new Array()

        // Labels
        this.animationsLabels = map(this.animated.labels, (element) => {
            return new Label({ element })
        })
        app.animations.push(...this.animationsLabels)

        // Titles
        this.animationsTitles = map(this.animated.titles, (element) => {
            return new Title({ element })
        })
        app.animations.push(...this.animationsTitles)

        // Excerpts
        this.animationsExcerpts = map(this.animated.excerpts, (element) => {
            return new Excerpt({ element })
        })
        app.animations.push(...this.animationsExcerpts)

         // Parallax
         this.animationsParallax = map(this.animated.parallaxed, (element) => {
            return new Parallax({ element })
        })
        app.animations.push(...this.animationsParallax)
    }

    /*
    ** Events
    */

    // On Loaded
    onPreloaded() {
        app.loading = false
        app.html.classList.remove('loading')
        app.html.classList.remove('scroll--off')

        this.preloaders = each(app.images, image => {
            return new AsyncLoad({ element: image })
        })

        if(app.preloader){ app.preloader.destroy() }
        this.onResize
    }
}

new App()